// extracted by mini-css-extract-plugin
module.exports = {"button-facebook":"FacebookLogin__button-facebook___1vc-L"};